import { useState, useCallback } from 'react'
import { useContactStrategy } from '../../../hooks/useContactStrategy.js'

export function useSupportButtonLogic() {
  const [showHelp, setShowHelp] = useState(false)
  const strategy = useContactStrategy()

  const toggleHelpModal = useCallback(() => {
    setShowHelp((prev) => !prev)
  }, [])

  return { showHelp, toggleHelpModal, shouldRender: strategy === 'custom' }
}
